import { Component, OnInit } from '@angular/core';
import { Roles } from 'src/app/models/role';
import { UserService } from 'src/app/shared/user/user-service.service';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.css']
})
export class RoleComponent implements OnInit {

  roles: Roles[];
  selectedValue: string;
  constructor(private userService: UserService) {
  }

  ngOnInit() {
    this.getRoles();
  }

  getRoles(): void {
    this.userService.getRoles().subscribe((roles => this.roles = roles) );
  }

}
